import React from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as Cafe } from '../../../resources/images/wagon-icons/cafe.svg';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonCafe({ style = {} }) {
  const { trans } = useTranslation();
  return (
    <div className="wagon-feature" style={style}>
      <Tooltip title={trans('cafe_bar')}>
        <Cafe />
      </Tooltip>
    </div>
  );
}

export default WagonCafe;
